import { useContext, useEffect, useState } from 'react';
import cssClass from './ContentUpdateMailerModal.module.css';
import { RoadmapContext } from '../../context/RoadmapContext';
import { useReactFlow } from '@xyflow/react';
import { useNotification } from '../../hooks/useNotification';
import { v4 as uuid4 } from 'uuid';
import { UserContext } from '../../context/UserContext';
import { useParams } from 'react-router-dom';
import closeIcon from '../../assets/close.svg';
import { motion } from 'framer-motion';

// Animation variants
const animationVariants = {
  backdrop: {
    hidden: {
      opacity: 0,
      transition: { duration: 0.2 },
    },
    visible: {
      opacity: 1,
      transition: { duration: 0.2 },
    },
  },
  modal: {
    hidden: {
      // y: 20,
      scale: 0.95,
      opacity: 0,
      transition: {
        duration: 0.2,
        ease: 'easeInOut',
      },
    },
    visible: {
      // y: 0,
      scale: 1,
      opacity: 1,
      transition: {
        duration: 0.2,
        ease: 'easeOut',
      },
    },
  },
};

const ContentUpdateMailerModal = ({ onCancel }) => {
  const { userDetails } = useContext(UserContext);
  const { contentUpdatedNodeDetails, setContentUpdateNodeDetails } =
    useContext(RoadmapContext);
  const { getNode } = useReactFlow();
  const { showLoadingNotification, resolveNotification, rejectNotification } =
    useNotification();
  const [nodedata, setNodeData] = useState([]);
  const [emailSubject, setEmailSubject] = useState('Roadmap Content Update');
  const [semdingEmail, setSendingEmail] = useState(false);

  const { roadmap_id } = useParams();

  const handleEmailSubjectChange = (e) => {
    setEmailSubject(e.target.value);
  };

  const handleSendClick = async () => {
    const toastId = uuid4();
    showLoadingNotification(toastId, 'Sending email update. Please wait');
    setSendingEmail(true);
    try {
      const data = {
        subject: emailSubject.trim(),
        node_details: nodedata,
      };
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/r/push-notification/${roadmap_id}?e=${userDetails?.email}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          // credentials: 'include',
          body: JSON.stringify(data),
        },
      );
      const responseData = await response.json();
      if (response.status === 200) {
        resolveNotification(toastId, 'Email sent successfully');
        onCancel();
        setContentUpdateNodeDetails([]);
        localStorage.removeItem(`pushEmailContentData_${roadmap_id}`);
      } else {
        rejectNotification(toastId, responseData?.error || responseData?.message || 'Something went wrong. Please try again');
      }
    } catch (error) {
      console.log(error);
      rejectNotification(toastId,'Something went wrong. Please try again');
    }
    setSendingEmail(false);
  };

  useEffect(() => {
    const extractDetails = () => {
      const grouped = {}; // For nodes with parent
      const result = []; // Final result array

      contentUpdatedNodeDetails.forEach((nodeEntry) => {
        const nodeId = nodeEntry.nodeId;
        const node = getNode(nodeId);
        if (!node) return;

        const parentId = node?.parentId;
        const childTitle = node?.data?.label;
        const childContent = nodeEntry.content;

        if (parentId) {
          const parent = getNode(parentId);
          const parentTitle = parent?.data?.label || '-';

          if (!grouped[parentId]) {
            grouped[parentId] = {
              parentTitle,
              childDetails: [],
            };
          }

          grouped[parentId].childDetails.push({id: nodeId, title: childTitle, content: childContent});
        } else {
          // No parent – push as separate entry
          result.push({
            parentTitle: '-',
            childDetails: [{id: nodeId, title: childTitle, content: childContent}],
          });
        }
      });

      // Combine grouped entries with individual parentless entries
      const groupedArray = Object.values(grouped);
      const finalResult = [...groupedArray, ...result];

      console.log(finalResult);
      setNodeData(finalResult);
    };

    extractDetails();
  }, [contentUpdatedNodeDetails]);

  return (
    <motion.div
      className={cssClass['backdrop']}
      onClick={onCancel}
      variants={animationVariants.backdrop}
      initial="hidden"
      animate="visible"
      exit="hidden"
      key="backdrop"
    >
      <motion.div
        className={cssClass['modal']}
        onClick={(e) => e.stopPropagation()}
        variants={animationVariants.modal}
        initial="hidden"
        animate="visible"
        exit="hidden"
        key="modal"
      >
        <div className={cssClass['title']}>Push Email Update</div>
        {contentUpdatedNodeDetails.length >= 1 ? (
          <>
            <div className={cssClass['email-ct']}>
              <div className={cssClass['subject-ct']}>
                <p className={cssClass['subject-text']}>Email Subject</p>
                <input
                  type="text"
                  className={cssClass['subject-input']}
                  value={emailSubject}
                  onChange={handleEmailSubjectChange}
                />
              </div>
              {
                <div className={cssClass['content-ct']}>
                  <p className={cssClass['content-head']}>Updated Contents</p>
                  <div>
                    <table className={cssClass['content-table']}>
                      <thead>
                        <tr>
                          <th>Module / Topic Title</th>
                          <th>Materials</th>
                        </tr>
                      </thead>
                      <tbody>
                        {nodedata.map((group, index) => (
                          <tr key={index}>
                            <td >{group?.parentTitle || '-'}</td>

                            <td className={cssClass['materials-col']}>
                              <table className={cssClass['inner-table']}
                              >
                                {
                                  index === 0 &&
                                  <thead>
                                    <tr>
                                      <th>Chapter Name</th>
                                      <th>Content Name</th>
                                    </tr>
                                  </thead>
                                }
                                <tbody>
                                  {group.childDetails?.map((child, cIndex) => (
                                    <tr key={cIndex}>
                                      <td>{child.title}</td>
                                      <td>
                                        {/* {child.content.sort((a, b) => a.id - b.id).map(cc => cc.title).join(', ')} */}
                                        <ol style={{paddingLeft: "15px"}}>
                                          {
                                            child.content.sort((a, b) => a.id - b.id).map((cc, idx) => (<li key={idx} style={{marginBottom: "5px"}}>{cc.title}</li>))
                                          }
                                        </ol>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              }
              <button
                className={cssClass['send-btn']}
                onClick={handleSendClick}
                disabled={semdingEmail}
              >
                Send
              </button>
            </div>
          </>
        ) : (
          <>
            <div>Please add a node to notification queue to send update</div>
            <div>{`Click on a Node > Click on "Content & Links" > Click on the "Add Icon" on top-right`}</div>
          </>
        )}
        <button className={cssClass['close-btn']} onClick={onCancel}>
          <img src={closeIcon} alt="close" />
        </button>
      </motion.div>
    </motion.div>
  );
};

export default ContentUpdateMailerModal;
